import { render } from "./CreateNewLevelModal.vue?vue&type=template&id=001f72f4"
import script from "./CreateNewLevelModal.vue?vue&type=script&lang=js"
export * from "./CreateNewLevelModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__